import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'ui';
import { WithCharacterBackground, Character } from 'ui/characters';
import StepCard from 'ui/components/StepCard';
import BeigeHeader from 'ui/layouts/BeigeHeader';

import s from './MainTestHeader.module.scss';

const cx = cn.bind(s);
const steps = [
  {
    title: 'Take Our Free Personality Test',
    text: 'Reflect on 60 statements and mark how closely each of them describes you',
    color: 'mint',
  },
  {
    title: 'Discover Your Personality Type',
    text: 'Explore your test results to learn what makes your personality type unique and how it influences your life',
    color: 'red',
  },
  {
    title: 'Dive Deeper Into Self-Awareness',
    text: 'Gain deep insight into your personality by upgrading to our optional Premium Profile',
    color: 'orange',
  },
];
const MainTestHeader = ({ className, ...attrs }) => (
  <BeigeHeader hasCircles={false} hasTorn className={cx(className, 'header')} {...attrs}>
    <Container>
      <Row>
        <Col md={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 6 }} xl={{ offset: 1, span: 6 }}>
          <h1
            className={cx(
              'tp-mobile-header-1 md:tp-tablet-header-1 xl:tp-header-1',
              'title',
            )}
          >
            Free personality test
          </h1>
          <p className={cx('tp-subheader', 'description', 'desktopDescription')}>
            Test your personality type, and find your strengths.
          </p>
        </Col>
        <Col
          xs={{ offset: 2, span: 8 }}
          md={{ offset: 4, span: 4 }}
          lg={{ offset: 0, span: 4 }}
          xl={4}
          className={cx('overflowedColumn')}
        >
          <WithCharacterBackground
            color="brown"
            position="bottom"
            className={cx('overflowedContent')}
          >
            <Character type="unknown-2" />
          </WithCharacterBackground>
        </Col>
        <Col xs={12} md={{ offset: 1, span: 10 }} className={cx('mobileDescription')}>
          <p className={cx('tp-subheader', 'description')}>
            Test your personality type, and find your strengths.
          </p>
        </Col>
      </Row>
      <div className={cx('steps')}>
        <Row>
          {steps.map((step, index) => (
            <Col
              key={index}
              md={{ offset: 3, span: 6 }}
              lg={{ offset: index === 0 ? 2 : 1, span: 2 }}
              className={cx('stepColumn', 'overflowedColumn')}
            >
              <StepCard className={cx('overflowedContent')} index={index + 1} {...step} />
            </Col>
          ))}
        </Row>
      </div>
      <Row>
        <Col md={{ offset: 1, span: 10 }} lg={{ offset: 2, span: 8 }}>
          <div className={cx('tp-subheader', 'footerDescription')}>
            <p>
              To take the personality test, mark your answers based on how well each statement
              describes you
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  </BeigeHeader>
);

MainTestHeader.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default MainTestHeader;
